import { BTPill, BTText } from "@btnet/core-components";

import {
    SpecificationOwnerShareMode,
    SpecificationSubShareMode,
} from "entity/specification/Specification.api.types";

interface ISpecificationViewableByDisplayProps {
    ownerShareMode: SpecificationOwnerShareMode;
    subShareMode: SpecificationSubShareMode;
}

function SpecificationViewableByDisplay(props: ISpecificationViewableByDisplayProps) {
    const { ownerShareMode, subShareMode } = props;

    const showClients = ownerShareMode === SpecificationOwnerShareMode.SharedWithAllOwners;
    const showSubs = subShareMode === SpecificationSubShareMode.SharedWithAllSubs;

    return (
        <div
            data-testid="specificationViewableBySection"
            className="flex flex-row SpecificationViewableByDisplay flex-wrap gap-1 py-3"
        >
            <BTText text="Viewable By" size="distinct-md" tag="h2" />
            <BTPill
                testid="specificationViewPageInternalPill"
                text="Internal"
                className="SpecificationViewableByDisplayPill"
            />
            {showClients && (
                <BTPill
                    testid="specificationViewPageClientPill"
                    text="Client"
                    className="SpecificationViewableByDisplayPill"
                />
            )}
            {showSubs && (
                <BTPill
                    testid="specificationViewPageSubPill"
                    text="Subs/vendors"
                    className="SpecificationViewableByDisplayPill"
                />
            )}
        </div>
    );
}

export default SpecificationViewableByDisplay;
